module.exports = __webpack_public_path__ + "media/images/pelna-historia-bcg-2addc919.png";